
/* eslint-disable */
import { createSlice } from '@reduxjs/toolkit';

import axios from '../../utils/axios.js';
import { dispatch } from '../index';
import { handleError, handleSuccess } from '../../utils/apiResponseHandler.js';

const initialState = {
    error: null,
    messagingTemplates: null,
    singleMessagingTemplate: null,
    loading: false,
    saveLoading: false,

    totalPages: null,
    totalCount: null,
};

const slice = createSlice({
    name: 'messagingTemplate',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },

        isLoading(state, action) {
            state.loading = action.payload;
        },

        isSaveLoading(state, action) {
            state.saveLoading = action.payload;
        },

        setMessagingTemplateDataSuccess(state, action) {
            state.messagingTemplates = action.payload?.data;
            state.totalPages = action.payload?.totalPages;
            state.totalCount = action.payload?.totalCount;
        },

        setSingleMessagingTemplateDataSuccess(state, action) {
            state.singleMessagingTemplate = action.payload;
        },

        updateMessagingTemplateDataSuccess(state, action) {
            const index = state.messagingTemplates.findIndex(messagingTemplate => messagingTemplate._id === action.payload.id);
            const apiKeyData = state.messagingTemplates[index];
            const newData = { ...apiKeyData, ...action.payload.data };
            state.messagingTemplates[index] = newData
        },

        createMessagingTemplateDataSuccess(state, action) {
            state.messagingTemplates.push(action.payload);
        },

        // deleteMessagingTemplateDataSuccess(state, action) {
        //     const newMessagingTemplates = state.messagingTemplates.filter(messagingTemplate => messagingTemplate._id !== action.payload.id);
        //     state.messagingTemplates = newMessagingTemplates;
        // },
    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------


export function getAllMessagingTemplates({page, limit, search }) {
    return async () => {
        try {
            dispatch(slice.actions.isLoading(true))

            const response = await axios.get(`/messaging/getCampaignTemplates?search=${search}`);
            dispatch(slice.actions.setMessagingTemplateDataSuccess(response?.data))

            return response?.data?.data;
        }
        catch (err) {
            handleError(err, dispatch);
        }
        finally {
            dispatch(slice.actions.isLoading(false))
        }
    }
}

export function createMessagingTemplate(data) {
    return async () => {
        try {
            dispatch(slice.actions.isSaveLoading(true))

            const response = await axios.post(`/messaging/createCampaignTemplate`, data);
            dispatch(slice.actions.createMessagingTemplateDataSuccess(response.data?.data))

            handleSuccess(response, "Messaging Template created successfully", dispatch);

            return response.data?.data;
        }
        catch (err) {
            handleError(err, dispatch);
            throw err
        }
        finally {
            dispatch(slice.actions.isSaveLoading(false))
        }
    }
}

export function updateMessagingTemplate(id, data) {
    return async () => {
        try {
            dispatch(slice.actions.isSaveLoading(true))

            const response = await axios.put(`/messaging/updateCampaignTemplate/${id}`, data);

            dispatch(slice.actions.updateMessagingTemplateDataSuccess(
                { data, id }
            ))
            handleSuccess(response, "Messaging Template updated successfully", dispatch);

            return response.data?.data;
        }
        catch (err) {
            handleError(err, dispatch);
            throw err
        }
        finally {
            dispatch(slice.actions.isSaveLoading(false))
        }
    }
}
